import React from 'react';
import { Phone, CheckCircle, AlertTriangle, Wrench } from 'lucide-react';
export function HorseTrailerRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6931">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6932">
        <div className="container mx-auto px-4" data-id="element-6933">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6934">
            Horse Trailer Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6935">
            Full Horse Trailer Repair and Maintenance Service
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6936">
        <div className="max-w-6xl mx-auto" data-id="element-6937">
          {/* Services Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6938">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-6939">
              <div data-id="element-6940">
                <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-6941">
                  Complete Horse Trailer Services
                </h2>

                <div className="space-y-3" data-id="element-6942">
                  <div className="flex items-start" data-id="element-6943">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6944" />
                    <span className="text-lg text-gray-700" data-id="element-6945">
                      We Service All brands of Horse Trailers
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6946">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6947" />
                    <span className="text-lg text-gray-700" data-id="element-6948">
                      Welding – frame, sidewall, studs walls, and more
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6949">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6950" />
                    <span className="text-lg text-gray-700" data-id="element-6951">
                      Sheet metal repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6952">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6953" />
                    <span className="text-lg text-gray-700" data-id="element-6954">
                      Stall dividers
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6955">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6956" />
                    <span className="text-lg text-gray-700" data-id="element-6957">
                      Horse Trailer Window repair and replacement
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6958">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6959" />
                    <span className="text-lg text-gray-700" data-id="element-6960">
                      Drop down feed, butt side, and more
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6961">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6962" />
                    <span className="text-lg text-gray-700" data-id="element-6963">
                      Ventilation system repairs
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6964">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6965" />
                    <span className="text-lg text-gray-700" data-id="element-6966">
                      Electrical system repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6967">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6968" />
                    <span className="text-lg text-gray-700" data-id="element-6969">
                      Axle maintenance and repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6970">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6971" />
                    <span className="text-lg text-gray-700" data-id="element-6972">
                      Living quarters repairs, furniture, sofas, dinettes,
                      countertops, cabinets, and more
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6973">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6974" />
                    <span className="text-lg text-gray-700" data-id="element-6975">
                      Appliances A/C, furnaces, water heaters, refrigerators,
                      and more
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center" data-id="element-6976">
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Flance-815-truck-camper-2008.jpg&site=1986&w=332&h=276&user=1617&opt=w3" alt="Horse Trailer Repair" className="rounded-lg shadow-md" style={{
                width: '332px',
                height: '276px'
              }} data-id="element-6977" />
              </div>
            </div>
          </div>

          {/* Tires, Wheels, Axles Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6978">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-6979">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-6980" />
              Horse Trailer Tires, Wheels, Axles, Spindles, Brakes Maintenance
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-6981">
              When it comes to your horses, safety always comes first. Before
              you load your horses into the trailer, be sure to hook up and
              perform a brief inspection of the tires and lights. Keep a tire
              gauge handy and check that the tire is holding the proper pressure
              (known as PSI).
            </p>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mb-6" data-id="element-6982">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6983">
                Horse Trailers Carry Valuable Cargo, Always Be On The Lookout
                for Dry Rot.
              </h3>
              <p className="text-gray-700" data-id="element-6984">
                Dry rot appears as tiny cracks in the tire. Dry rot can occur
                even if the tire tread still looks great, and once those cracks
                show up, your tire becomes compromised. And again, remember to
                inspect your spare tires too. Because of dry rot, you should
                plan on replacing tires every three to five years regardless of
                appearance.
              </p>
            </div>

            {/* Tire Images */}
            <div className="flex justify-center gap-4 mb-8" data-id="element-6985">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/horse-trailers/trailer-tire-maintenance.jpg?opt=w3" alt="Trailer tire maintenance" className="rounded-lg shadow-sm" data-id="element-6986" />
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/horse-trailers/trailer-tires.jpg300x800.jpg?opt=w3" alt="Trailer tires" className="rounded-lg shadow-sm" data-id="element-6987" />
            </div>
          </div>

          {/* Maintenance Tips */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6988">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-6989">
              Essential Maintenance Tips
            </h2>

            <div className="space-y-8" data-id="element-6990">
              {/* Air Pressure */}
              <div className="border-l-4 border-blue-500 pl-6" data-id="element-6991">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6992">
                  Check the air pressure in the tires before heading out on a
                  trip.
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-6993">
                  Always check the pressure when the tires are cold. The
                  pressure changes as tires heat up from travel. And don't
                  forget the spare tires. The correct pressure for your horse
                  trailer tires is located right on the tires. Most tire
                  blowouts happen because a tire wasn't properly inflated, so
                  take a few minutes to check before you leave.
                </p>
                <img src="http://tbn0.google.com/images?q=tbn:P03I1xkWvR9SkM:http://www.germes-online.com/direct/dbimage/50312190/Tire_Pressure_Gauge.jpg" alt="Tire pressure gauge" className="border rounded shadow-sm" style={{
                width: '121px',
                height: '121px'
              }} data-id="element-6994" />
              </div>

              {/* Right Tires */}
              <div className="border-l-4 border-green-500 pl-6" data-id="element-6995">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6996">
                  Make sure you've got the right tires on your horse trailer.
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-6997">
                  Horse trailers require specific tires, primarily because of
                  the load they're carrying. Therefore, use tires rated for the
                  appropriate weight.
                </p>
                <img src="http://tbn1.google.com/images?q=tbn:A1UpoiCSkISb4M:http://static.howstuffworks.com/gif/tire-overloaded.jpg" alt="Overloaded tire" className="border rounded shadow-sm" style={{
                width: '124px',
                height: '93px'
              }} data-id="element-6998" />
              </div>

              {/* Wheel Bearings */}
              <div className="border-l-4 border-purple-500 pl-6" data-id="element-6999">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7000">
                  Don't forget to inspect wheel bearings.
                </h3>
                <p className="text-gray-700" data-id="element-7001">
                  Wheel bearing failure is a tire-related issue that can happen
                  while you're traveling. To avoid this problem, plan to service
                  your trailer's wheel bearings every 12 months or 12,000 miles,
                  whichever comes first. Moisture buildup seriously affects the
                  bearing grease, which leads to bearing failure. This is why
                  regular service is recommended.
                </p>
              </div>
            </div>
          </div>

          {/* Safety Summary */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-7002">
            <div className="flex items-start" data-id="element-7003">
              <AlertTriangle className="text-red-600 mr-4 flex-shrink-0 mt-1" size={32} data-id="element-7004" />
              <div data-id="element-7005">
                <h2 className="text-2xl font-bold text-red-900 mb-4" data-id="element-7006">
                  Safety First for Your Horses
                </h2>
                <ul className="space-y-2 text-gray-800" data-id="element-7007">
                  <li className="flex items-start" data-id="element-7008">
                    <span className="mr-2" data-id="element-7009">•</span>
                    <span data-id="element-7010">Inspect tires and lights before every trip</span>
                  </li>
                  <li className="flex items-start" data-id="element-7011">
                    <span className="mr-2" data-id="element-7012">•</span>
                    <span data-id="element-7013">
                      Check tire pressure when cold (including spares)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7014">
                    <span className="mr-2" data-id="element-7015">•</span>
                    <span data-id="element-7016">Look for dry rot cracks in tires</span>
                  </li>
                  <li className="flex items-start" data-id="element-7017">
                    <span className="mr-2" data-id="element-7018">•</span>
                    <span data-id="element-7019">
                      Replace tires every 3-5 years regardless of appearance
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7020">
                    <span className="mr-2" data-id="element-7021">•</span>
                    <span data-id="element-7022">
                      Service wheel bearings every 12 months or 12,000 miles
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7023">
                    <span className="mr-2" data-id="element-7024">•</span>
                    <span data-id="element-7025">Use tires rated for appropriate weight</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7026">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7027">
              Expert Horse Trailer Repair & Maintenance
            </h2>
            <p className="text-xl mb-6" data-id="element-7028">
              Keep your horses safe with professional trailer service
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7029">
              <Phone className="mr-3" size={24} data-id="element-7030" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7031">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}